import { parseYear, rangeInclusive } from './common';

export const getRequiredYears = (
  supplyStartDate?: string | null | Date,
  supplyFinalDate?: string | null | Date,
  globalSupplyStartDate?: string | null | Date,
  globalSupplyFinalDate?: string | null | Date,
  aux__useDifferentPeriodsByUnit?: boolean,
): string[] => {
  let startYear: number | null = null;
  let endYear: number | null = null;

  if (aux__useDifferentPeriodsByUnit) {
    startYear = parseYear(supplyStartDate);
    endYear = parseYear(supplyFinalDate);
  } else {
    startYear = parseYear(globalSupplyStartDate);
    endYear = parseYear(globalSupplyFinalDate);
  }

  if (!startYear || !endYear) return [];

  const years = rangeInclusive(startYear, endYear);
  return years.map((year) => `year${year}`);
};
